var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.items,"label":_vm.inputLabel,"item-text":"text","item-value":"value","clearable":true,"outlined":"","dense":""},on:{"input":event => { _vm.emitChange(event) }},model:{value:(_vm.selectedItem),callback:function ($$v) {_vm.selectedItem=$$v},expression:"selectedItem"}})
}
var staticRenderFns = []

export { render, staticRenderFns }